(()=>{
  const rename=()=>document.querySelectorAll('[data-mue-ai-nav]').forEach(link=>{
    if(link.textContent.trim()!=='AI STYLE FINDER')link.textContent='AI STYLE FINDER';
  });
  const init=()=>{
    rename();
    const header=document.querySelector('.shopify-section-header')||document.querySelector('sticky-header')||document.querySelector('header');
    if(header)new MutationObserver(rename).observe(header,{childList:true,subtree:true});
    document.querySelector('.mue-bella-entry__button')?.addEventListener('click',()=>{
      const data={event:'style_finder_bella_entry',theme_version:'0.28',entry:'bella'};
      window.dataLayer=window.dataLayer||[];window.dataLayer.push(data);
      window.mueDataLayer=window.mueDataLayer||[];window.mueDataLayer.push(data);
      try{window.Shopify?.analytics?.publish?.(data.event,{theme_version:'0.28',entry:'bella'})}catch{}
    });
  };
  // This script follows the entry markup, so its header and button already
  // exist. Do not wait for unrelated deferred storefront scripts.
  init();
  document.addEventListener('shopify:section:load',rename);
})();
